import {Decoration, ViewPlugin, WidgetType} from '@codemirror/view'
import {syntaxTree} from '@codemirror/language'

class ColorSwatch extends WidgetType {
  constructor(color) { super(); this.color = color }
  eq(other) { return other.color === this.color }
  toDOM() {
    const swatch = document.createElement('span')
    swatch.className = 'cm-brand-color-swatch'
    swatch.style.backgroundColor = this.color
    swatch.title = this.color
    swatch.setAttribute('role', 'img')
    swatch.setAttribute('aria-label', this.color)
    return swatch
  }
  ignoreEvent() { return true }
}

function decorations(view) {
  const widgets = []
  for (const range of view.visibleRanges) {
    syntaxTree(view.state).iterate({from: range.from, to: range.to, enter(node) {
      if (!['ColorLiteral', 'ValueName', 'CallExpression'].includes(node.name)) return
      let parent = node.node.parent
      while (parent && parent.name !== 'Declaration') parent = parent.parent
      if (!parent) return
      const value = view.state.doc.sliceString(node.from, node.to)
      if (value.length > 150 || !CSS.supports('color', value) || /^(var\(|inherit$|initial$|unset$|currentcolor$)/i.test(value)) return
      widgets.push(Decoration.widget({widget:new ColorSwatch(value), side:-1}).range(node.from))
      return false
    }})
  }
  return Decoration.set(widgets, true)
}

export const colorPreviews = ViewPlugin.fromClass(class {
  constructor(view) { this.decorations = decorations(view) }
  update(update) {
    if (update.docChanged || update.viewportChanged) this.decorations = decorations(update.view)
  }
}, {decorations: plugin => plugin.decorations})
